/* import __COLOCATED_TEMPLATE__ from './edhr.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();